
import Vue from 'vue'
import Router from 'vue-router'

import RewriteRoute from '@/views/rewriteRoute'

import Magazine from '@/views/overview/magazine'
import LibrarySearch from '@/views/overview/librarysearch'
import Book from '@/views/overview/book'
import Audio from '@/views/overview/audio'
import Newspaper from '@/views/overview/newspaper'
import Video from '@/views/overview/video'
import PlayerVideo from '@/views/detail/playervideo'
import DownloadClient from '@/views/downloadClient'
import AdvancedSearch from '@/views/overview/advancedsearch'
import AdvancedSearchResults from '@/views/advancedSearchResults'
import Mine from '@/views/mine'
import BookCase from '@/views/mine/bookCase'
import Collection from '@/views/mine/collection'
import UserSetting from '@/views/mine/userSetting'

import AllRank from '@/views/allRank'

import AllCates from '@/views/allCates'

import SearchResults from '@/views/searchResults'

import DetailAudio from '@/views/detail/audio'
import DetailVideo from '@/views/detail/video'
import DetailPaper from '@/views/detail/paper'
//import PastMagazine from '@/views/pastMagazine'
import PastMagazine from '@/views/past/pastMagazine'
import PastNewspaper from '@/views/past/pastNewspaper'
import TextReading from '@/views/use/textReading'
import TextPrint from '@/views/use/textPrint'
import OriginalMagazine from '@/views/use/originalReading'

import statisticalgetdata from '@/apis/src/statistical'
const allRoutes = [
    {
        path: '/rewriteRoute',
        name: 'rewriteRoute',
        component: RewriteRoute
    },
    {
        path: '/magazine',
        name: 'magazine',
        component: Magazine
    },
    {
        path: '/book',
        name: 'book',
        component: Book
    },
    {
        path: '/audio',
        name: 'audio',
        component: Audio
    },
    {
        path: '/newspaper',
        name: 'newspaper',
        component: Newspaper
    },
    {
        path: '/video',
        name: 'video',
        component: Video
    },
    {
        path: '/articleLibrary',
        name: 'articleLibrary',
        component: LibrarySearch
    },
    {
        path: '/downloadClient',
        name: 'downloadClient',
        component: DownloadClient
    },
    {
        path: '/advancedsearch',
        name: 'advancedSearch',
        component: AdvancedSearch
    },
    {
        path: '/advancedSearchResults/:sourcetype/:pageNumber/:sortType/:title/:titleLogic/:content/:contentLogic/:minDate/:minDateLogic/:maxDate/:maxDateLogic/:magazineName/:magazineNameLogic/:year/:yearLogic/:issue/:issueLogic',
        name: 'advancedSearchResults',
        component: AdvancedSearchResults
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine,
        redirect: {
            name: 'collection'
        },
        children: [
            {
                path: '/mine/collection',
                name: 'collection',
                component: Collection
            },
            {
                path: '/mine/bookCase',
                name: 'bookCase',
                component: BookCase
            },
            {
                path: '/mine/userSetting',
                name: 'userSetting',
                component: UserSetting
            }
        ]
    },
    {
        path: '/allRank/:resourceType/:typeIndex',
        name: 'allRank',
        component: AllRank
    },
    {
        path: '/allCates/:resourceType/:cateCode',
        name: 'allCates',
        component: AllCates
    },
    {
        path: '/searchResults/:resourceType/:searchWord',
        name: 'searchResults',
        component: SearchResults
    },
    {
        path: '/detailAudio/:id/:cateCode/:cateName',
        name: 'detailAudio',
        component: DetailAudio
    },
    {
        path: '/textPrint/:resourceType/:id/:year/:issue/:articleId/:token',
        name: 'textPrint',
        component: TextPrint
    },
    {
        path: '/detailVideo/:id/:cateCode/:cateName',
        name: 'detailVideo',
        component: DetailVideo
    },
    {
        path: '/playerVideo/:id/:sequence',
        name: 'playerVideo',
        component: PlayerVideo
    },
    {
        path: '/detailPaper/:resourceType/:id/:year/:issue/:cateCode/:cateName',
        name: 'detailPaper',
        component: DetailPaper
    },
    {
        path: '/pastMagazine/:id/:cateName',
        name: 'pastMagazine',
        component: PastMagazine
    },
    {
        path: '/pastNewspaper/:id/:year/:month',
        name: 'pastNewspaper',
        component: PastNewspaper
    },
    {
        path: '/textReading/:resourceType/:id/:year/:issue/:articleId/:token',
        name: 'textReading',
        component: TextReading
    },
    /*{
        path: '/textReadingWithToken/:resourceType/:articleId/:token',
        name: 'textReadingWithToken',
        component: TextReading
    },*/
    {
        path: '/magazineOriginalReading/:id/:year/:issue/:count',
        name: 'magazineOriginalReading',
        component: OriginalMagazine
    },
    {
        path: '/',
        redirect: '/RewriteRoute'
    },
    {
        path: '*',
        redirect: '/RewriteRoute'
    }
]

Vue.use(Router)


// Config router
const router = new Router({
    routes: allRoutes
})

router.beforeEach((to, from, next) => {
    const { params } = to
    for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
            const value = params[key]
            params[key] = `${ value }`
        }
    }
    next()
})
statisticalgetdata.startstatistical(router);
export default router
